import { Component, OnInit } from '@angular/core';
import { LookupService } from 'src/app/services/Common/lookup.service';
import { GlobalHelper } from 'src/app/services/Common/global.service';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import * as moment from 'moment';
import { StudentPortalService } from 'src/app/services/StudentPortal/student-portal.service';

@Component({
  selector: 'app-student-fee-challan',
  templateUrl: './student-fee-challan.component.html',
  styleUrls: ['./student-fee-challan.component.css']
})
export class StudentFeeChallanComponent implements OnInit {
  constructor(private spinnerService: Ng4LoadingSpinnerService, private studentPortalService: StudentPortalService, private lookupService: LookupService, public globalHelper: GlobalHelper) { }

  ChallanTransactionList: any;
  GetStudentFeeChallan() {
    this.studentPortalService.GetStudentFeeChallan().subscribe((response: any) => {
      this.ChallanTransactionList = response.ChallanTransactionList;
      this.globalHelper.CheckActionStatus(response);

    });
  };




  ngOnInit() {
    this.GetStudentFeeChallan();
  }

  // Print Challan

  PrintFeeChallan(ReceiptNo,ChallanTemplate) {
    var Template = ChallanTemplate;
    var url = Template + "?PrintTypes=FeeReceipt&ReceiptNo=" + ReceiptNo;
    this.globalHelper.OpenPopUpWindow(url, "yes", "950", "1000");
  };

}
